// pages/messenger/messenger-job-complete-multi.jsx
// ─────────────────────────────────────────────────────────
// FIXED:
//   - ใช้ WF, getStopBadge, getEmail จาก shared utils (ลบโค้ดซ้ำ)
//   - ใช้ RouteArrow component
// ─────────────────────────────────────────────────────────

import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import RequestService from '../../services/requestService';
import { WF } from '../../components/utils/messenger-constants';
import { getStopBadge, getEmail } from '../../components/utils/messenger-helpers';
import RouteArrow from '../../components/common/route-arrow';

const MessengerJobCompleteMulti = () => {
    const navigate          = useNavigate();
    const { id: encodedId } = useParams();
    const id                = atob(encodedId);

    const [job, setJob]               = useState(null);
    const [selectedStops, setSelectedStops] = useState([]);
    const [selectAll, setSelectAll]   = useState(false);
    const [loading, setLoading]       = useState(false);

    useEffect(() => {
        const fetchJob = async () => {
            try {
                const resp = await RequestService.GetRequestById(id);
                if (resp?.data?.is_success === true) {
                    setJob(resp.data.result);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchJob();
    }, [id]);

    const details  = job?.request_details || [];
    const wfStatus = job?.id_workflow_status;
    const pending  = details.filter(d => d.is_complete != 1);

    const handleToggleAll = () => {
        if (selectAll) {
            setSelectAll(false);
            setSelectedStops([]);
        } else {
            setSelectAll(true);
            setSelectedStops(pending.map(d => String(d.seq)));
        }
    };

    const handleToggleStop = (seqStr) => {
        setSelectedStops(prev => {
            const next = prev.includes(seqStr)
                ? prev.filter(s => s !== seqStr)
                : [...prev, seqStr];
            setSelectAll(next.length === pending.length);
            return next;
        });
    };

    const handleConfirm = async () => {
        if (selectedStops.length === 0 && !selectAll) return;
        setLoading(true);
        try {
            const isAllDone = selectAll || selectedStops.length === pending.length;

            for (const seqStr of selectedStops) {
                const d = details.find(d => String(d.seq) === seqStr);
                if (d) {
                    await RequestService.PatchRequestDetail(d.id, {
                        is_complete: 1,
                        update_by: getEmail(),
                    });
                }
            }

            if (isAllDone) {
                await RequestService.ChangeWorkflowStatus(id, {
                    id_workflow_status: WF.COMPLETE,
                    update_by: getEmail(),
                });
            }

            const totalStops = details.length;
            const doneSeq    = isAllDone
                ? totalStops
                : Number(selectedStops[selectedStops.length - 1]);

            navigate(
                `/messenger/job-done/${btoa(id)}/${btoa(String(doneSeq))}/${btoa(String(totalStops))}`,
                { replace: true }
            );
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mim-root">
            <div className="mim-header">
                <button className="mim-close" onClick={() => navigate(-1)}>
                    <i className="mdi mdi-close" />
                </button>
                <h2 className="mim-title">ส่งสำเร็จ</h2>
            </div>

            <div className="mim-body">
                <p className="mim-label">เลือกจุดส่ง</p>
                <div className="mim-list mim-list--no-border">

                    <label className="mim-option">
                        <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleToggleAll}
                        />
                        <span>ทั้งหมด</span>
                    </label>

                    {details.map((d, i) => {
                        const seqStr     = String(d.seq ?? i + 1);
                        const badge      = getStopBadge(d.is_complete, wfStatus); // ✅ ใช้ shared helper
                        const isDisabled = d.is_complete == 1;

                        return (
                            <div key={d.id}>
                                <label className={`mim-option ${isDisabled ? 'mim-option--disabled' : ''}`}>
                                    <input
                                        type="checkbox"
                                        checked={selectedStops.includes(seqStr) || isDisabled}
                                        onChange={() => !isDisabled && handleToggleStop(seqStr)}
                                        disabled={isDisabled}
                                    />
                                    <span>จุดที่ {d.seq ?? i + 1}</span>
                                </label>

                                <div className="mim-stop-card">
                                    <div className="mim-stop-card-header">
                                        <span className="mjd-label">
                                            Ref No. {job?.ref_no}{(d.seq ?? i + 1) > 1 ? `-${(d.seq ?? i + 1) - 1}` : ''}
                                        </span>
                                        <span className={`mmj-badge mmj-badge--${badge.type}`}>
                                            {badge.label}
                                        </span>
                                    </div>
                                    <div className="mim-stop-card-route">
                                        <div className="mim-stop-route-item">
                                            <span className="mjd-label">ต้นทาง</span>
                                            <span className="mjd-value">{d.origin_building_name || '-'}</span>
                                        </div>
                                        <RouteArrow /> {/* ✅ ใช้ shared component */}
                                        <div className="mim-stop-route-item">
                                            <span className="mjd-label">ปลายทาง</span>
                                            <span className="mjd-value">{d.destination_name || d.destination_company || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="mim-footer">
                <button
                    className="mim-btn mim-btn--primary"
                    onClick={handleConfirm}
                    disabled={loading || (selectedStops.length === 0 && !selectAll)}
                >
                    ยืนยัน
                </button>
                <button className="mim-btn mim-btn--ghost" onClick={() => navigate(-1)}>
                    <i className="mdi mdi-arrow-left" /> กลับไปก่อนหน้า
                </button>
            </div>
        </div>
    );
};

export default MessengerJobCompleteMulti;